(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-collectible-browse"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',(event)=>{
const link=event.target.closest('.ms-character-links a');
if(!link)return;
const destination=new URL(link.href);
const current=new URL(window.location.href);
for(const [key,value] of current.searchParams){if(key!=='page'&&!destination.searchParams.has(key))destination.searchParams.append(key,value)}
link.href=destination.href;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-restock-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
const trigger = event.target.closest('[data-ms-restock]');
const dialog = document.getElementById('ms-restock-dialog');
if (!dialog) return;
if (trigger) {
event.preventDefault();event.stopPropagation();
const variant = trigger.dataset.variant;
const label = trigger.dataset.title + (variant && variant !== 'Default Title' ? ' — ' + variant : '');
dialog.querySelector('[data-ms-restock-product]').textContent = label;
const body = dialog.querySelector('#ms-restock-body');
if (body) body.value = 'Please let me know when this item is back in stock: ' + label + '\nVariant ID: ' + trigger.dataset.id + '\n' + trigger.dataset.url;
sessionStorage.setItem('ms-restock-pending', label);dialog.showModal();
}
if (event.target.closest('[data-ms-restock-close]')) dialog.close();
});
const restockDialog = document.getElementById('ms-restock-dialog');
if (restockDialog && sessionStorage.getItem('ms-restock-pending') && (restockDialog.querySelector('[data-ms-restock-success]') || restockDialog.querySelector('.errors'))) {
restockDialog.querySelector('[data-ms-restock-product]').textContent = sessionStorage.getItem('ms-restock-pending');
restockDialog.showModal();
if (restockDialog.querySelector('[data-ms-restock-success]')) sessionStorage.removeItem('ms-restock-pending');
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-shop-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',(event)=>{const menu=event.target.closest('.ms-shop-shell .msv-menu');document.querySelectorAll('.ms-shop-shell .msv-menu[open]').forEach(item=>{if(item!==menu||event.target.closest('a'))item.removeAttribute('open')})});
document.addEventListener('keydown',(event)=>{if(event.key==='Escape')document.querySelectorAll('.ms-shop-shell .msv-menu[open]').forEach(item=>{item.removeAttribute('open');item.querySelector('summary').focus()})});
  } catch(e) { console.error(e); }
})();

})();
